<h1>Voorwaarden en garantie</h1>

<h2>Dekservice</h2>
De dektarieven verschillen per dekhengst. Kijk bij de dekhengst voor zijn tarief.

<h3>Mogelijkheden</h3>
<ol>
<li>U komt met uw merrie langs. Ze wordt gedekt en na de dekking neemt u haar weer mee naar huis. U dient zelf aan te geven of de dekking is geslaagd. Zo niet, dan kunt u opnieuw langs komen.</li>
<li>Wij komen met de dekhengst bij u langs voor een dekking. U dient zelf te controleren of de dekking is geslaagd. Als wij na 40 dagen niets van u hebben gehoord, gaan we ervan uit dat de dekking is gelukt. Mocht blijken dat uw merrie niet drachtig is, dan komen wij uiteraard nogmaals bij u langs.</li>
</ol>

<h3>Gezondheidsverklaring</h3>
Om gezondheidsredenen dient u voor uw merries een gezondheidsverklaring te overhandigen. Hierin verklaart uw veearts dat uw dieren zijn ingeënt tegen clostridia, ontwormd zijn en vrij zijn van schurft. De gezondheidsverklaring mag niet ouder zijn dan 14 dagen.

<h3>Dekbewijs</h3>
Na de dekking krijgt u een dekbewijs mee. Hiermee kunt u aantonen welke hengst het veulen als vader heeft.

<h3>Levend geboren veulen garantie</h3>
Bij de dekservice wordt een garantie afgegeven op een levend geboren veulen tot de leeftijd van 30 dagen. Dit is een extra garantie bovenop de voorwaarden uit het contract. Indien het veulen binnen die tijd overlijd, kan er kosteloos een nieuwe dekking plaatsvinden. Wij vragen u wel om een overlijdensverklaring van uw dierenarts.

<h2>Verkoop</h2>

<h3>AAB geregistreerd en gechipt</h3>
De dieren die verkocht worden zijn voorzien van een microchip en ingeschreven bij de AAB. Sommige van onze dieren zijn naast de AAB ook ingeschreven bij een ander register, zoals de AAA (Australië) of BAS (Engeland).

<h3>Gezondheidsverklaring en keuring</h3>
Al onze dieren worden verkocht inclusief het volledige medisch dossier dat wij hebben opgebouwd gedurende de tijd dat het dier in ons bezit was.
<p></p>
Indien gewenst verstrekken wij bij verkoop een gezondheidsverklaring van onze dierenarts. U kunt ook door uw eigen dierenarts een gezondheidsverklaring laten opstellen.
<p></p>
Op verzoek kunnen wij ook een aankoopkeuring voor u aanvragen. 

<h3>Verkoop ruin</h3>
Wanneer wij een dier verkopen als ruin, dan is de koper verplicht de alpaca te laten castreren als dit nog niet gebeurd is. Een alpaca die wij verkopen als ruin is per definitie niet geschikt voor de topfokkerij. 

<h3>Garantie bij verkoop van fokkerij geschikte alpaca</h3>
Wanneer wij een dier verkopen dat wij fokkerij geschikt achten, dan krijgt u van ons een vruchtbaarheidsgarantie tot een bepaalde leeftijd. 

<h3>Levend geboren veulen garantie</h3>
Bij verkoop van een drachtige merrie krijgt u dezelfde garantie op een levend geboren veulen als bij een dekking. U krijgt van ons dus een dekbewijs en levend geboren veulen garantie tot de leeftijd van 30 dagen. 

<h2>Niet inbegrepen bij de prijs</h2>
Prijzen op deze site zijn exclusief transport- en exportkosten. Ook een gezondheidsverklaring en een aankoopkeuring zijn voor uw eigen rekening. 
